module.exports = __webpack_public_path__ + "img/bil1.05e3a40b.jpg";